import { render, staticRenderFns } from "./ProficientSetting.vue?vue&type=template&id=2d83d733&scoped=true"
import script from "./ProficientSetting.vue?vue&type=script&lang=js"
export * from "./ProficientSetting.vue?vue&type=script&lang=js"
import style0 from "./ProficientSetting.vue?vue&type=style&index=0&id=2d83d733&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d83d733",
  null
  
)

export default component.exports